import {ChangeDetectorRef, Component, ElementRef, inject, Input, OnInit, ViewChild} from '@angular/core';
import {BaseRecordTableItemComponent} from '../base-record-table-item/base-record-table-item.component';
import {RecordDataValue} from '../../../../types/records-table.types';
import {UtilityService} from "../../../../services/utility.service";

@Component({
  selector: 'app-number-record-table-item',
  standalone: false,
  templateUrl: './number-record-table-item.component.html',
  styleUrls: [
    './number-record-table-item.component.scss',
    '../base-record-table-item-styles.scss'
  ]
})
export class NumberRecordTableItemComponent extends BaseRecordTableItemComponent implements OnInit {
  @Input() isFilter?: boolean;
  @ViewChild('inputField') inputField!: ElementRef;

  private utilityService: UtilityService = inject(UtilityService);
  private cdr: ChangeDetectorRef = inject(ChangeDetectorRef);

  public isInputFocused: boolean = false;
  private currentValue: RecordDataValue;

  public ngOnInit(): void {
    this.currentValue = this.value;
    this.updateInputFocusState();
  }

  public getPostfix(): string {
    if (this.value === null || this.value === undefined) { return ''; }

    return this.columnParam.columnProperties.POSTFIX?.value ?? '';
  }

  public getPrefix(): string {
    if (this.value === null || this.value === undefined) { return ''; }

    return this.columnParam.columnProperties.PREFIX?.value ?? '';
  }

  public formatNumberValue(): RecordDataValue {
    if (this.value === null || this.value === undefined) {
      return;
    }

    const numberValue = Number(this.value);
    return this.utilityService.formatNumberForDisplay({
      value: numberValue,
      fractional: this.columnParam.columnProperties.FRACTIONAL,
      numberSeparator: this.columnParam.columnProperties.NUMBER_SEPARATOR
    });
  }

  public handleInputEvent(event: Event): void {
    const value = this.validationService.allowPaste(event);
    if (value === null) {
      this.value = this.currentValue;
      return;
    }

    this.value = value;
  }

  public preventInvalidNumericInput(event: KeyboardEvent, isDecimalPoint: boolean = false) {
    this.validationService.preventInvalidNumericInput(event, isDecimalPoint);
  }

  public focusInput() {
    if (!this.isPossibleToEdit()) { return; }
    this.isInputFocused = true;
    this.cdr.detectChanges();
    this.inputField.nativeElement.focus();
  }

  private updateInputFocusState(): void {
    if (this.isFilter) {
      this.isInputFocused = this.isFilter;
    }
  }
}
